import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import ReactDom from "react-dom";
import ComboHeader from "../ComboHeader/ComboHeader";
import { IconButton, Tooltip, styled } from "@mui/material";
import CircleLoader from "../Loaders/CircleLoader";
import DownloadIcon from "../../assets/icons/download-icon.svg";

const ButtonWrapper = styled("div")({
  button: {
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "6px",
    display: "flex",
    padding: "8px 12px",
    span: {
      color: "#0DA9D5",
      fontSize: "12px",
      fontWeight: "600",
      letterSpacing: "0.15em",
      marginRight: "5px",
      whiteSpace: "nowrap",
    },
  },
});

const LoaderWrapper = styled("div")({
  "& img": {
    maxWidth: "18px",
    maxHeight: "16px",
  },
});

function Card({
  children,
  style,
  className,
  expandable,
  absoluteExpandButton,
  header,
  app,
  cardContentStyle,
  exportTable,
  exportTableId,
  exportContainer,
  exportTablesId,
}) {
  const [isExpanded, setExpand] = useState(false);
  const mounted = useRef();
  const [loadingExcel, setLoadingExcel] = useState(false);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const handleExpand = () => {
    if (mounted.current) {
      setExpand(!isExpanded);
    }
  };

  const exportToXLS = async (objectsId) => {
    setLoadingExcel(false);

    if (exportTablesId) {
      objectsId.map(async (item) => {
        let id = item;

        if (exportContainer) {
          await app.visualization
            .get(item)
            .then((vis) => {
              id = vis.model.items.activeId;
            })
            .catch(() => setLoadingExcel(false));
        }

        if (app && id) {
          setLoadingExcel(true);
          await app.visualization
            .get(id)
            .then((vis) => {
              vis.table
                .exportData({
                  format: "OOXML",
                  state: "A",
                })
                .then((link) => {
                  setLoadingExcel(false);
                  const xlsLink = `https://${
                    process.env.REACT_APP_HOST + process.env.REACT_APP_PREFIX
                  }${link.substring(link.indexOf("tempcontent"))}`;
                  window.open(xlsLink);
                });
            })
            .catch(() => setLoadingExcel(false));
        }
      });
    } else {
      let id = objectsId;

      if (exportContainer) {
        await app.visualization
          .get(objectsId)
          .then((vis) => {
            id = vis.model.items.activeId;
          })
          .catch(() => setLoadingExcel(false));
      }

      if (app && id) {
        setLoadingExcel(true);
        await app.visualization
          .get(id)
          .then((vis) => {
            vis.table
              .exportData({
                format: "OOXML",
                state: "A",
              })
              .then((link) => {
                setLoadingExcel(false);
                const xlsLink = `https://${
                  process.env.REACT_APP_HOST + process.env.REACT_APP_PREFIX
                }${link.substring(link.indexOf("tempcontent"))}`;
                window.open(xlsLink);
              });
          })
          .catch(() => setLoadingExcel(false));
      }
    }
  };

  const Content = () => (
    <div
      className={isExpanded ? "expandedCardContainer" : `${className} card`}
      style={style}
    >
      <div
        className={isExpanded ? "expandedCardContent" : "cardContentArea"}
        style={cardContentStyle}
      >
        <div
          className="cardHeader"
          style={{
            justifyContent: header ? "space-between" : "flex-end",
          }}
        >
          {header && (
            <ComboHeader
              app={app}
              reference={{
                title: {
                  id: header.titleId,
                  hard: header.hardTitle,
                },
                subtitle: {
                  id: header.subtitle,
                  hard: header.hardSubtitle,
                },
              }}
              tooltip={header.tooltip}
              legends={header.legends}
              radio={header.radio}
              classStyle={header.classStyle}
              scale={header.scale}
            />
          )}
          {expandable && (
            <div
              className={
                absoluteExpandButton
                  ? "primaryButton expandButton absolute"
                  : "primaryButton expandButton"
              }
              style={{
                flexDirection: "row",
                justifyContent: "end",
              }}
            >
              <ButtonWrapper>
                <Tooltip title={isExpanded ? "Reduzir" : "Ampliar"}>
                  <IconButton type="button" onClick={() => handleExpand()}>
                    <i className="fal fa-expand" />
                  </IconButton>
                </Tooltip>
              </ButtonWrapper>
            </div>
          )}
          {exportTable && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                padding: "0px 4px 12px",
              }}
            >
              <ButtonWrapper>
                <Tooltip title="Exportar para Excel">
                  <IconButton
                    type="button"
                    onClick={() => exportToXLS(exportTableId)}
                  >
                    <span>Exportar </span>
                    {!loadingExcel ? (
                      <img src={DownloadIcon} alt="icon-downloaf" />
                    ) : (
                      <LoaderWrapper>
                        <CircleLoader />
                      </LoaderWrapper>
                    )}
                  </IconButton>
                </Tooltip>
              </ButtonWrapper>
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
  return isExpanded ? (
    ReactDom.createPortal(
      <Content />,
      document.getElementById("expandedWrapper")
    )
  ) : (
    <Content />
  );
}
Card.defaultProps = {
  children: null,
  style: null,
  className: "",
  expandable: false,
  header: null,
  app: null,
  cardContentStyle: {},
  absoluteExpandButton: false,
  exportTableId: [],
  exportTable: false,
  exportContainer: false,
  exportTablesId: false,
};
Card.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  expandable: PropTypes.bool,
  className: PropTypes.string,
  header: PropTypes.object,
  app: PropTypes.object,
  absoluteExpandButton: PropTypes.bool,
  cardContentStyle: PropTypes.object,
  exportTableId: PropTypes.array,
  exportTable: PropTypes.bool,
  exportContainer: PropTypes.bool,
  exportTablesId: PropTypes.bool,
};
export default Card;
